import Swal from 'sweetalert2';


const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-success',
      cancelButton: 'btn btn-danger'
    },
    buttonsStyling: false
  })
  
  
  
  
  export const confirmQuantities = (onClickFunc, data, success, func) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Clicking on YES button will set all quantities to done.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, set quantities!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        func();
        // console.log(data)
        onClickFunc(data, success, swalWithBootstrapButtons);
      }
    });
  }
  